import { FaSpinner } from 'react-icons/fa6'

export const LoadingOverlay = () => {
  return (
    <div
      className={
        'absolute left-0 top-0 z-10 h-full w-full bg-slate-600 opacity-50'
      }
    >
      <div className={'flex h-full w-full items-center justify-center'}>
        <FaSpinner className="h-16 w-16 animate-spin" />
      </div>
    </div>
  )
}
